<div
    cdkDropList
    class="ordered-item-selector__selected-items"
    [cdkDropListOrientation]="'mixed'"
    [cdkDropListDisabled]="isDisabled()"
    (cdkDropListDropped)="_onDrop($event)"
>
    @for (
        selectedItem of selectedItems();
        track selectedItem;
        let index = $index;
        let last = $last
    ) {
        <div
            class="ordered-item-selector__item"
            [class.ordered-item-selector__item--disabled]="isDisabled()"
            cdkDrag
        >
            <lg-ordered-item
                [menuItem]="_menuItemNamesDict()[selectedItem]"
                [selectedItem]="selectedItem"
                [itemPosition]="index + 1"
                [isDisabled]="isDisabled()"
                (toggleMenu)="_toggleMenu(_menuType.ReplaceItemMenu, $event)"
                (removeItem)="_removeItem($event)"
            />

            <lg-ordered-item-menu
                [isOpen]="_activeMenu()[_menuType.ReplaceItemMenu] === selectedItem"
            >
                @for (menuItem of menuItems(); track menuItem.id) {
                    <button
                        class="ordered-item-selector__menu-item"
                        (click)="_handleButtonMenuItemClick(menuItem, selectedItem)"
                    >
                        {{ menuItem.name }}
                    </button>
                }
            </lg-ordered-item-menu>
        </div>

        @if (!last) {
            <lg-icon class="ordered-item-selector__arrow" [icon]="'icon-arrow-right'" />
        }
    }

    <div class="ordered-item-selector__add-section">
        @if (
            !isDisabled() &&
            !(this.selectedItems().length >= this.maxItems()) &&
            _filteredMenuItems().length > 0
        ) {
            <button
                class="ordered-item-selector__add-button"
                (click)="_toggleMenu(_menuType.AddItemMenu)"
            >
                <lg-icon [icon]="'icon-add'" />

                <span>{{ ".AddButton" | lgTranslate }}</span>
            </button>
        }

        <lg-ordered-item-menu [isOpen]="_activeMenu()[_menuType.AddItemMenu]">
            @for (menuItem of _filteredMenuItems(); track menuItem.id) {
                <button
                    class="ordered-item-selector__menu-item"
                    (click)="_handleAddItemMenuClick(menuItem.id)"
                >
                    {{ menuItem.name }}
                </button>
            }
        </lg-ordered-item-menu>
    </div>

    @if (!isDisabled() && _resolvedError(); as error) {
        <lg-icon
            class="ordered-item-selector__error-icon"
            [type]="error.type"
            [icon]="error.icon"
            [clickable]="false"
            [lgSimpleTooltip]="error.message"
        />
    }
</div>
